import React, { useEffect, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { Button, Icon, classnames } from "@culturehq/components";

import { CreatomatePropertyValue } from "chq";
import { Trans } from "app/utils";

interface TextAligmentProps {
  activeElement: ElementState;
  disabled?: boolean;
  onSubtitlePropChange?: (propertyName: string, value: CreatomatePropertyValue) => Promise<void>;
  preview: Preview;
}

const TextAligment: React.FC<TextAligmentProps> = ({
  activeElement, disabled, onSubtitlePropChange, preview
}) => {
  const [aligmentButton, setAligmentButton] = useState({
    left: false, center: false, right: false
  });

  useEffect(
    () => {
      const getTextAligment = () => {
        switch (activeElement.source.x_alignment) {
          case "0%":
          case undefined:
            setAligmentButton({ left: true, center: false, right: false });
            break;
          case "50%":
            setAligmentButton({ left: false, center: true, right: false });
            break;
          case "100%":
            setAligmentButton({ left: false, center: false, right: true });
            break;
          default:
            break;
        }
      };

      if (activeElement.source?.type === "text") {
        getTextAligment();
      }
    }, [activeElement]
  );

  const changeTextAligment = async (value: string) => {
    if (onSubtitlePropChange) {
      await onSubtitlePropChange("x_alignment", value);
    } else {
      await preview.applyModifications({
        [`${activeElement.source.id}.x_alignment`]: value
      });
    }
  };

  const handleLeftAligmentClick = async () => {
    setAligmentButton({ left: true, center: false, right: false });
    await changeTextAligment("0%");
  };

  const handleCenterAligmentClick = async () => {
    setAligmentButton({ left: false, center: true, right: false });
    await changeTextAligment("50%");
  };

  const handleRightAligmentClick = async () => {
    setAligmentButton({ left: false, center: false, right: true });
    await changeTextAligment("100%");
  };

  return (
    <div className="AlignmentOptions--Primary">
      <Trans><span className="chq-ffd--lb">Alignment</span></Trans>
      <div className="pnl-align-option">
        <Button
          className={classnames(
            "btn-text-align-option", { "btn-align-option-active": aligmentButton.left }
          )}
          disabled={disabled}
          onClick={handleLeftAligmentClick}
        >
          <Icon icon="text-align-left" />
        </Button>
        <Button
          className={classnames(
            "btn-text-align-option", { "btn-align-option-active": aligmentButton.center }
          )}
          disabled={disabled}
          onClick={handleCenterAligmentClick}
        >
          <Icon icon="text-align-center" />
        </Button>
        <Button
          className={classnames(
            "btn-text-align-option", { "btn-align-option-active": aligmentButton.right }
          )}
          disabled={disabled}
          onClick={handleRightAligmentClick}
        >
          <Icon icon="text-align-right" />
        </Button>
      </div>
    </div>
  );
};

export default TextAligment;
